import {
  AvatarCardLinkWidgetFields,
  AvatarCardLinkWidgetFormFields,
} from 'components/consumer-page-widgets/avatar-card-link-widget/AvatarCardLinkWidgetFormFields';
import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import { Form, Formik } from 'formik';
import { Widgets } from '@tock/shared/types/widget';
import {
  getBaseFormFieldsInitialValues,
  useCreateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface CreateAvatarCardLinkWidgetFormProps {
  onCompleteOrCancel(): void;
}

export const CreateAvatarCardLinkWidgetForm: FunctionComponent<
  React.PropsWithChildren<CreateAvatarCardLinkWidgetFormProps>
> = ({ onCompleteOrCancel }) => {
  const createNamedConfig = useCreateNamedConfigurations();

  const handleSubmit = ({
    name,
    imageAlt,
    imageUrl,
    title,
    subtitle,
    linkText,
    linkHref,
  }: AvatarCardLinkWidgetFields) => {
    return createNamedConfig({
      name: name,
      widgetType: Widgets.WidgetCreatorWidgetType,
      avatarCardLinkWidgetConfig: {
        imageAlt: imageAlt,
        imageUrl: imageUrl,
        title: title,
        subtitle: subtitle,
        linkText: linkText,
        linkHref: linkHref,
      },
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Create widget</Typography>
      <Formik<AvatarCardLinkWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues(),
          imageUrl: '',
          imageAlt: '',
          title: '',
          subtitle: '',
          linkText: '',
          linkHref: '',
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <AvatarCardLinkWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button variant="outlined" type="button" onClick={onCompleteOrCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
